import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { MatSnackBar } from '@angular/material';

@Injectable({
    providedIn: 'root'
})
export class UtilsService {
    constructor(
        private snackBar: MatSnackBar,
        @Inject(LOCALE_ID) public locale: string
    ) {}

    newSnackbar(text: any, snackBarClass: any, d?: number) {
        let duration = d;
        if (!duration) {
            duration = 3000;
        }
        return this.snackBar.open(`${text}`, '', {
            duration: duration,
            panelClass: snackBarClass
        });
    }

    newSuccessSnackbar(text: any, duration?: number) {
        return this.newSnackbar(text, 'success', duration);
    }

    newWarningSnackbar(text: any, duration?: number) {
        return this.newSnackbar(text, 'warn', duration);
    }

    newErrorSnackbar(text: any, duration?: number) {
        return this.newSnackbar(text, 'error', duration);
    }

    formatDateTimeline(date: any): Array<string> {
        const options = {
            year: 'numeric',
            month: 'long',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        };
        if (isNaN(+date) && date !== null) {
            return date.split('-').concat(date.split(' ')[1]);
        } else {
            return new Date(+date)
                .toLocaleString(this.locale, options)
                .toLocaleUpperCase()
                .split(' ');
        }
    }

    setNewCronologiaClass(isMine: boolean) {
        if (isMine) {
            return 'cronologia-card cronologia-card-right mat-card';
        } else {
            return 'cronologia-card cronologia-card-left mat-card';
        }
    }
}
